import { render, staticRenderFns } from "./OrderGridItem.vue?vue&type=template&id=7b544465&scoped=true&"
import script from "./OrderGridItem.vue?vue&type=script&lang=js&"
export * from "./OrderGridItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b544465",
  null
  
)

export default component.exports